import { render } from "./Help.vue.js?vue&type=template&id=31d4aa6d!=!../vue-loader/dist/index.js??ruleSet[0]!./Help.vue?vue&type=template&id=31d4aa6d"
import script from "./Help.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./Help.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__